import React from 'react';

function WidgetGetinTouch({ heading, text, icon }) {
    let href = "";
    if (text.includes("@")) {
        href = `mailto:${text}`;
    } else if (heading.toLowerCase().includes("location")) {
        href = "";
    } else if (heading.toLowerCase().includes("phone") || /^\+?[0-9\s-]+$/.test(text)) {
        href = `tel:${text.replace(/\s+/g, "")}`;
    } 

    return (
        <>
            <div className="single-contact-info">
                <div className="icon" style={{width: "40px", height:"40px"}}>{icon}</div>
                <div className="contact-info">
                    <span>{heading}</span>
                    <p>
                        {href ? (
                            <a 
                            href={href} 
                            style={{ 
                                color: "inherit", 
                                textDecoration: "none", 
                                fontSize: "inherit", 
                                fontWeight: "400", 
                                lineHeight: "inherit" }}
                            >
                                {text}
                            </a>
                        ) : (
                            text
                        )}
                    </p>
                </div>
            </div>
        </>
    );
}

export default WidgetGetinTouch;
